import React from 'react';
import ProfileScreen from "../components/Profile/ProfileScreen";

const Profile = () => {
    return (
        <div className="w-screen h-screen">
            <ProfileScreen />
        </div>
    );
};

export default Profile;